import { vnApp } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app";
export class vnApp_leadpilot extends vnApp {
    // Roles IDs.
    static { this.ROLE_ID_ADMINISTRATOR = 1; }
    // Sections IDs.
    static { this.SECTION_ID_TAKEOVER = 1; }
    static { this.SECTION_ID_USER = 2; }
    static { this.SECTION_ID_ROLE = 3; }
    static { this.SECTION_ID_LOG = 4; }
    static { this.SECTION_ID_TASK = 5; }
    static { this.SECTION_ID_USER_OTHERS = 6; }
    static { this.SECTION_ID_USER_EDIT_ROLES_ADMIN = 7; }
    static { this.SECTION_ID_USER_OTHERS_ALL = 8; }
    static { this.SECTION_ID_BRANDS_ALL = 9; }
    static { this.SECTION_ID_ADVERTISING_PARTNER = 10; }
    static { this.SECTION_ID_USER_EDIT_ROLES = 11; }
    static { this.SECTION_ID_USER_EDIT_BRANDS = 12; }
    static { this.SECTION_ID_USER_EDIT_ACTIVE = 13; }
    getIsLoggedInHttpCallUrl() {
        return '/api/access/isLoggedIn/';
    }
}
